var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.02139,
    cy: 8.52139,
    r: 7.01872,
    stroke: "white",
    strokeWidth: 2.00535
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1408 12.5035C8.19882 8.56146 8.19882 8.56146 12.1408 4.61944C14.318 2.44232 17.8478 2.44232 20.0249 4.61944C22.202 6.79656 22.202 10.3264 20.0249 12.5035C17.8478 14.6806 14.318 14.6806 12.1408 12.5035Z",
    fill: "#20AF14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 8.2005C13.6364 7.09298 14.5342 6.19515 15.6417 6.19515L18.6096 6.19515L18.6096 8.2005L13.6364 8.2005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6818 10.8477C14.5743 10.8477 13.6765 9.94983 13.6765 8.84231L17.1257 8.84231L17.1257 10.8477L15.6818 10.8477Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00135 6.51996L6.01605 8.49996L8.00135 10.48",
    stroke: "white",
    strokeWidth: 2.00535,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.7180aab090ab221117c3a62b5d0f72bd.svg";
export { ForwardRef as ReactComponent };